import { type Game } from '../game/types';

export interface UserProfile {
  avatar: string;
  username: string;
  firstName: string;
  lastName: string;
  telegramId: number;
  wallets: Wallet[];
  gameSessionsCount: number;
  gameOfTheDay: Game;
  avdNetworks: AD_NETWORK[];
  currentGameStarted: number;
  country: string;
  fromClicker: boolean;
  tests: {
    labels: string[];
    miniGame?: boolean;
    miniGameV2?: boolean;
    noAd?: boolean;
  };
}

export interface Wallet {
  type: WalletType;
  balance: number;
  totalEarned: number;
  minAmountToWithdraw: number;
  activeBooster: WalletBooster;
  activeBoosters: WalletBooster[];
  isExpiredBoosterExists: boolean;
  level: number;
}

export interface WalletBooster {
  id: number;
  value: number;
  activeTo: number;
  gameKey: string;
  txCause: string;
  selectionKey: string;
}

export enum WalletType {
  PLAYCOIN = 'PLAYCOIN',
  PREMIUM = 'PREMIUM',
  XP = 'XP',
}

export interface PushMessage {
  telegramUserId: number;
  text: string;
  button: {
    text: string;
    params: string | { [key: string]: any };
  };
}

export enum AD_NETWORK {
  AG = 'AG',
  MT = 'MT',
  PD = 'PD',
  Y = 'Y',
}

export interface CloudSavedData {
  data: string;
  key: string;
}

export interface TgWebInitData {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date?: number;
  hash: string;
}
